import { addMinutes } from 'date-fns';

export const DELAY = addMinutes(new Date(), 10);
